enum PermissionLevel {
    ADMIN = 1,
    STAFF = 2,
    GUEST = 3
};

export default PermissionLevel;